import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {ItemKey} from "@/modules/redactor/models/item/core/ItemKey";

export class ItemCluster extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._items = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    valid() {

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.items.length <= 0 || this.items.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.items.length <= 0;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemCluster());
        } else if (target instanceof ItemCluster) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemCluster, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _items: alias("items", list(ItemKey.schema()))
});